import { tw } from '../../styles/tw';
import { Advertisement, AdvertisementId } from '../../components/Advertisement';
import { TagType } from '../../lib/graphql.document';

interface TagDescriptionProps {
  tagName: string;
  tagType: TagType;
}

const TagDescription = ({ tagName, tagType }: TagDescriptionProps) =>
  tagType === TagType.Section ? (
    <Advertisement
      id={AdvertisementId.DesktopTagSectionSideBanner}
      className={tw('mx-auto my-0 hidden max-w-[var(--main-max-width)] md:flex')}
    />
  ) : (
    <h1 className="overflow-anywhere text-xl lg:mt-6">{tagName}</h1>
  );

export default TagDescription;
export { TagDescription };
